export interface PurchaseOrderStatusItem {
  id: string;
  orderStatus: string;
  user: string;
  processedDate: Date;
}
